<template>
	<div :class="classNames+ '_card'">
		<div :class="classNames+ '_card-list'">
			<div :class="classNames+ '_card-item'" v-for="(item,cidx) in listData.data" :key="cidx">
				<div :class="classNames+ '_card-item-title'" @click.stop="setCardId(item)">
					<h4>{{item.title}}</h4>
					<el-radio :label="item.id" v-model="ruleForm.card_id"><span></span></el-radio>
				</div>
				<div :class="classNames+ '_card-item-content'">
					<div :class="classNames+ '_card-item-body'" v-if="item.card_type == 1">
						{{item.content}}
					</div>
					<div :class="classNames+ '_card-item-body'" v-if="item.card_type == 2">
						<p><img :src="item.image" alt="" class="card-intro-image"></p>
						<p>{{item.content}}</p>
					</div>
					<div :class="classNames+ '_card-item-body'" v-if="item.card_type == 3">
						<p><img :src="item.image" alt="" class="card-intro-image"></p>
						<p>{{item.content}}</p>
						<div v-for="items of item.components.split(',')" :key="items">
							<p v-if="items == 1">姓名:如何称呼您？</p>
						</div>
					</div>
					<div :class="classNames+ '_card-item-body'" v-if="item.card_type == 4">
						<p>{{item.content}}</p>
						<p><span :class="classNames+ '_text_color'">拨打电话</span></p>
					</div>
				</div>
			</div>
		</div>
		<div :class="classNames+ '_card-pagin'">
			<Pagination @change="changeSize" :total="listData.total" ref="pagination" v-model="searchObj.page"
				v-if="Math.ceil(listData.total / searchObj.limit) > 1"></Pagination>

		</div>
	</div>
</template>
<script>
	import {
		mapActions
	} from 'vuex'
	import Pagination from '@/components/pagination/pagination.vue'
	export default {
		props: {
			value: {
				type: String,
				default: ''
			},
			data: {
				type: Object,
				default: () => ({
					card_id:  ''
				})
			},
			listData: {
				type: Object,
				default: () => ({
					data: [],
					total: 0
				})
			},
			search: {
				type: Object,
				default: () => ({
					page: 1,
					limit: 10
				})
			},
		},
		components: {
			Pagination
		},
		data() {
			return {
				classNames: 'markerdy',
			}
		},
		computed: {
			ruleForm: {
				get() {
					return this.data
				},
				set(news) {
					
				}
			},
			searchObj: {
				get() {
					return this.search
				},
				set(news) {
					
				}
			}
		},
		methods: {
			...mapActions('dymessage', ['cardsList']),
			changeSize(size) {
				this.$emit("getCardList",size);
			},
			setCardId(data){
				this.$emit("getCardId",data.id);
			}
		}
	}
</script>
<style lang="less">
	@classNames: markerdy;
	.@{classNames}_card {
		background-color: #f2f2f2;
		padding: 20px;
		border-radius: 4px;
		flex-direction: column;
	}

	.@{classNames}_card-list {
		height: 500px;
		overflow: auto;

		.el-form-item {
			margin-bottom: 20px;
			margin-left: -40px;
		}

		.@{classNames}_card-item {
			width: 180px;
			height: 240px;
			float: left;
			border: 1px solid #eeeeee;
			background-color: #fff;
			margin-right: 10px;
			margin-bottom: 10px;
			padding: 0 10px;
			;
		}

		.@{classNames}_card-item:nth-child(2n) {
			margin-right: 0px;
		}

		.@{classNames}_card-item-title {
			display: flex;
			justify-content: space-between;
			align-items: center;
			height: 40px;

			h4 {
				word-break: break-all;
				overflow: hidden;
				display: -webkit-box;
				-webkit-line-clamp: 1;
				-webkit-box-orient: vertical;
			}

		}

		.@{classNames}_card-item-content {
			height: 200px;
			overflow: auto
		}
	}
	.card-intro-image{
		width: 100%; 
		max-height: 120px;
	}
	.@{classNames}_card-pagin {
		width: 100%;
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		line-height: 1;

		.pagination_wrap {
			padding-top: 10px;
			padding-bottom: 0px;
		}
	}
</style>
